import { render, staticRenderFns } from "./HostProcessSpace.vue?vue&type=template&id=0cb7a8f4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostProcessSpace.vue"
export default component.exports